const handleAttachFile = {
  toastrCreateTitle: 'Adjunto agregado',
  toastrCreateMessage: 'El archivo adjunto se agregó con éxito.',
  toastrCreateErrorTitle: 'Error',
  toastrCreateErrorMessage: 'Error al agregar archivo adjunto',

  toastrEditTitle: 'Adjunto editado',
  toastrEditMessage: 'Adjunto editado con éxito.',
  toastrEditErrorTitle: 'Error',
  toastrEditErrorMessage: 'Error al editar el archivo adjunto',

  toastrDeleteTitle: 'Adjunto eliminado',
  toastrDeleteMessage: 'El archivo adjunto se eliminó con éxito.',
  toastrDeleteErrorTitle: 'Error',
  toastrDeleteErrorMessage: 'Error al eliminar archivo adjunto',
};

export default handleAttachFile;